import React from 'react';

const KeepWindowOpen = (props) => 
{
    if (!props.showKeepWindowMsg) {
        return null;
    }
    return (
        <div className="form-group text-center">
            <p className="mobile-flow-warning" style={{ fontSize: '14px', backgroundColor: '#fff3cd', padding: '5px' }}>Keep this browser window open so that the flow will continue once the consent has been authorized.</p>
        </div>
    );
}

export default KeepWindowOpen
